import { useState, useEffect } from "react";
import FormData from "form-data";
import axios from "axios";
import * as ReactBootStrap from "react-bootstrap";


function Form16() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    Pan_Number: "",
    Name_of_Employee: "",
    Period_From: "",
    Period_To: "",
    Employee_Address: "",
  });
  const [img, setImg] = useState();
    const [loading , setLoading] = useState(true)

  
  useEffect(() => {
    console.log(cardData);
  }, [cardData]);
  
  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";
    
    var reader = new FileReader();
    console.log("next");
    
    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };
  
  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      Pan_Number: "",
      Address: "",
      Name: "",
      Assessment_year: "",
      Acknowledgement_Number: "",
      Form_Number: "",
      Total_Income: "",
      QR_Code_Number: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://toz1av1nw4.execute-api.ap-south-1.amazonaws.com/default/itrocrservice",
      headers: {
        "x-api-key": "jCSIISHVNG2e3QLKbX0P82l6LyFM4oLj3mAyUH5R",
        authorizationToken: "pUTnRSr8FQfFpBgS",
      },
      data: data,
    };
    
    axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      setCardData(response.data);
      setLoading(true)
    })
    .catch(function (error) {
      setLoading(true)
      alert("Something went wrong with server");
      console.log(error);
    });
  };
  
  useEffect(() => {}, [cardData]);
  
  return (
    <div>
    <div>
    <div class="container containerBoreder " id="pan">
    <h2 class="pageTitle">Income Tax return OCR</h2>
    <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
    <br />
    <table class="table">
    <tbody>
    <tr>
    <th width="25%">Pan Number</th>
    <td>{cardData.Pan_Number}</td>
    </tr>
    <tr>
    <th>Address</th>
    <td>{cardData.Address}</td>
    </tr>
    <tr>
    <th>Name</th>
    <td>{cardData.Name} </td>
    </tr>
    <tr>
    <th>Assessment year</th>
    <td>{cardData.Assessment_year}</td>
    </tr>
    <tr>
    <th>Form Number</th>
    <td>{cardData.Form_Number}</td>
    </tr>
    <tr>
    <th>Total Income</th>
    <td>{cardData.Total_Income}</td>
    </tr>
    <tr>
    <th>QR Code Number</th>
    <td>{cardData.QR_Code_Number}</td>
    </tr>
    </tbody>
    </table>
    </div>
    </div>
    </div>
    );
  }
  
  export default Form16;
  